import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";

// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
	Select,
	InputLabel,
	Input,
	// MenuItem,
	Modal,
	Backdrop,
	Fade,
	FormHelperText,
	NativeSelect,
	Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";

import { NavLink } from "react-router-dom";
//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
}));

const SalesProduction = () => {
	const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [downloadFlag, setDownloadFlag] = useState(false);
	const [open, setOpen] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: new Date(),
	});
	const classes = useStyles();

	const [useridNo, setuseridNo] =  useState(get_cookies('branchidno'));

	// Data Fetching
	useEffect(() => {
		data();
	}, []);
	
	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	useEffect(() => {
		if(posts.length > 0){
			setDownloadFlag(true);
		}else{
			setDownloadFlag(false);
		}
	}, [posts]);
	//search button
	const dataFilter = async () => {
		setDataLoaded(false);
        const result = await axios.get(
			process.env.REACT_APP_API_URL+'sales_production_report', {
            params:{
                date_from: format(dateRange.startDate, "yyyy/MM/dd/"), //format(dateRange.startDate, "yyyy/MM/dd/")
                date_to: format(dateRange.endDate, "yyyy/MM/dd/"),   //format(dateRange.endDate, "yyyy/MM/dd/")
                jc_user_id_no: useridNo,  
            }
        })
		setPosts(result.data.data);
		setDataLoaded(true);
    }

	const data = async () => {
		setDataLoaded(true);
	};

	const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
	};
	const columns = [
		{
			name: "d4",
			label: "D4",
				options: {
				setCellProps: value => ({ style: { textAlign: 'right' } }),
			}
		},
		{
			name: "d3",
			label: "D3",
				options: {
				setCellProps: value => ({ style: { textAlign: 'right' } }),
			}
		},
		{
			name: "d2",
			label: "D2",
				options: {
				setCellProps: value => ({ style: { textAlign: 'right' } }),
			}
		},
		{
			name: "d1",
			label: "D1",
				options: {
				setCellProps: value => ({ style: { textAlign: 'right' } }),
			}
		},
		{
			name: "platinum",
			label: "Platinum",
				options: {
				setCellProps: value => ({ style: { textAlign: 'right' } }),
			}
		},
		{
			name: "gold",
			label: "gold",
				options: {
				setCellProps: value => ({ style: { textAlign: 'right' } }),
			}
		},
		{
			name: "gold",
			label: "gold",
				options: {
				setCellProps: value => ({ style: { textAlign: 'right' } }),
			}
		},
		{
			name: "silver",
			label: "Silver",
				options: {
				setCellProps: value => ({ style: { textAlign: 'right' } }),
			}
		},
		{
			name: "startup",
			label: "Startup",
				options: {
				setCellProps: value => ({ style: { textAlign: 'right' } }),
			}
		},
		{
			name: "primary",
			label: "Primary",
				options: {
				setCellProps: value => ({ style: { textAlign: 'right' } }),
			}
		},
		{
			name: "secondary",
			label: "Secondary",
				options: {
				setCellProps: value => ({ style: { textAlign: 'right' } }),
			}
		},
		{
			name: "team_total",
			label: "Team Total",
				options: {
				setCellProps: value => ({ style: { textAlign: 'right' } }),
			}
		},
	];

	const options = {
		filter: true,
		// filterType: "dropdown",
		selectableRows: "none",
		filterType: "multiselect",
		responsive: "standard",
		setFilterChipProps: (colIndex, colName, data) => {
			//console.log(colIndex, colName, data);
			return {
				color: "primary",
				variant: "outlined",
				className: "testClass123",
			};
		},   
		download: downloadFlag,  //add this
		print: downloadFlag, //add this
		downloadOptions: {
			filename : 'SalesProductionReport.csv' //change filename of csv
		}
		// tableBodyHeight,
	};

    const style = {
		marginBottom: '1rem',
		marginTop:"2.5em",
	};

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<AssessmentTwoTone />
				</div>
				<NavLink to={"/reports"}><h4 style={{color:"#339933"}}>Reports</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<h4>Sales Production Report</h4>
			</div>
			<div className="page-container">
				<div style={style}>
					<Grid container spacing={1}>
                            <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                <TextField
                                    id="outlined-basic"
                                    label="Select Date"
                                    variant="outlined"
                                    onFocus={() => setOpen(true)}
                                    fullWidth={true}
                                    autoComplete="off"
                                    value={`${format(
                                        dateRange.startDate,
                                        "MM/dd/yyyy"
                                    )} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
                                />
                                <DateRangePicker
                                    open={open}
                                    toggle={toggle}
                                    onChange={(range) => dateRangeHandler(range)}
                                /> 
                            </Grid>

						{/* <Grid item xs={2}>
							<Input style ={{marginTop: "24px"}} placeholder="Branch ID No" inputProps={{ 'aria-label': 'branch id no' }} onChange={e => setuseridNo(e.target.value)}/>
						</Grid> */}

						<Grid item xs={1} xl={1}> 
							<Button style ={{marginTop: "23px"}} variant="contained" color="primary"  onClick={() => {dataFilter()}}>Search</Button>
						</Grid>
					</Grid>
				</div>
				{!dataLoaded ? (
					<Preloader />
				) : (
					<MUIDataTable
						title={
							<div>
						
								<div className="table-title">
								Sales Production Report
								</div>
							</div>
						}
						data={posts}
						columns={columns}
						options={options}
					/>
				)}
			</div>
		</div>
	);
};

export default SalesProduction;
